import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'

import { Component, Input, OnInit } from '@angular/core'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { catchError, take, timeout } from 'rxjs/operators'
import { operationActions } from '../../../operation/operation.actions'
import { NotificationService } from '../../../../core/notification.service'
import { CollectStatusType, Payment } from '../../payment/payment'
import { paymentActions } from '../../payment/payment.actions'
import { getEnumAsArray } from '../../../../shared/until'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SalePaymentModalComponent implements OnInit {
  @Input() salePayment: Payment
  public form: UntypedFormGroup
  public CollectStatusType = getEnumAsArray(CollectStatusType)

  constructor(
    private fb: UntypedFormBuilder,
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      collectStatus: [this.salePayment.collectStatus, []]
    })
  }

  public cancel() {
    this.bsModalRef.hide()
  }

  onFormSubmit() {
    this.store.dispatch(
      paymentActions.updateOneById({
        id: this.salePayment.id,
        params: { collectStatus: this.form.controls.collectStatus.value }
      })
    )

    this.actions$
      .pipe(
        ofType(paymentActions.upsertMany),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe((action) => {
        if (!action) {
          console.error('Failed to update before timeout')
          return false
        }

        this.notificationService.emit('alerts.success', 'success')

        this.store.dispatch(
          operationActions.updateOneById({
            id: this.salePayment.id,
            params: { isPending: false }
          })
        )

        this.modalService.hide()
      })
  }
}
